import styled from 'styled-components';
import bgImg from '../../images/contact_bg.jpg';

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  min-height: 500px;
  background-image: url(${bgImg});
  background-size: cover;
  .contact-page-row {
    position: relative;
    max-width: ${props => props.theme.maxWidth};
    margin: auto;
    background: rgba(255, 255, 255, 0.9);
    padding: 1em;
    border-radius: 20px;
    left: ${props => props.viewable ? 0 : -100 }%;
    transition: left 0.8s ease;
  }
  .contact-page-col {
    padding: 20px;
    a {
      color: #333;
      font-size: 1.4em;
      margin: 0;
      font-weight: 400;
      text-decoration: underline;
    }
  }
  img {
    width: 100px;
    margin: auto;
    display: block;
  }
`;

export const Title = styled.h1`
  font-size: 1.5em;
  font-weight: 400;
  margin: 0 auto;
  padding: 4.5em 1em 1em;
  max-width: ${props => props.theme.maxWidth};
  @media (min-width: 768px) {
    font-size: 2.25em;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ContactPage/Styles.js